module.exports = __webpack_public_path__ + "images/first-board-low-fidelity-card-back.dc72914ec7ff5c2e9df9.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/first-board-low-fidelity-card-back.svg
// module id = I4ED
// module chunks = 12